<template>
  <v-snackbar
      v-model="visible"
      :color="color"
      top
      multi-line
  >
    <div class="toast-content">
      <v-icon left dark class="toast-icon">{{ icon }}</v-icon>
      <span>{{ message }}</span>
    </div>
    <v-btn icon @click="visible = false" color="white" x-small>
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'RootToastManager',
  data() {
    return {
      message: '',
      type: 'default', // 'success', 'error', 'info', etc.
      visible: false
    }
  },
  created() {
    this.$root.$on('toast', this.showToast)
  },
  computed: {
    color() {
      switch (this.type) {
        case 'success': return 'green'
        case 'error': return 'red'
        case 'warning': return 'orange'
        default: return 'blue'
      }
    },
    icon() {
      switch (this.type) {
        case 'success': return 'mdi-check-circle'
        case 'error': return 'mdi-alert-circle'
        case 'warning': return 'mdi-alert'
        default: return 'mdi-information'
      }
    }
  },
  methods: {
    showToast({message, type = 'info'}) {
      this.message = message
      this.type = type
      this.visible = true
    }
  }
}
</script>

<style scoped>
</style>
